import api from '~/services/api';

function salvaEstatistica(data) {
  return api.post('Estatistica', data);
}

export { salvaEstatistica };
